import { motion } from "framer-motion";
import PDFViewer from "../UI/elements/PdfView";
import DocView from "../UI/elements/DocView";
import { isPdf, getDocumentFileUrl } from "../../utils/documentFiles";

const pdfViewerAnimation = {
    initial: { opacity: 0, scale: 0.96 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.96, transition: { duration: 0.3 } },
    transition: { duration: 0.3 },
};

function DocumentViewer({
    currentDocument,
    printType,
    customPages,
    onLoadSuccess,
    printColor,
    orientation,
}) {
    // Не-PDF (офисные форматы и изображения) идут через /convert/:id — см. documentFiles.js
    const needsConversion = !isPdf(currentDocument.file_name);
    const file = getDocumentFileUrl(currentDocument);

    return (
        <motion.div
            {...pdfViewerAnimation}
            className="flex-1 min-h-0 w-full flex flex-col"
        >
            {needsConversion ? (
                <DocView
                    file={file}
                    printType={printType}
                    customPages={customPages}
                    onLoadSuccess={onLoadSuccess}
                    printColor={printColor}
                    orientation={orientation}
                />
            ) : (
                <PDFViewer
                    file={file}
                    printType={printType}
                    customPages={customPages}
                    onLoadSuccess={onLoadSuccess}
                    printColor={printColor}
                    orientation={orientation}
                />
            )}
        </motion.div>
    );
}

export default DocumentViewer;
